import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../services/data.service';
import { CommonService } from '../services/common.service';
import { Documento, AttachmentDto, TipologiaServiceITADto } from '../models/data.model';
import { MimetypeService } from '../services/mimetype.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-service-ita',
  templateUrl: './service-ita.component.html',
  styleUrls: ['./service-ita.component.css']
})
export class ServiceItaComponent implements OnInit {

  idTipologia: string;
  tipologia: any;
  documentType: string;
  documents: Documento[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private tipologiaService: CommonService<TipologiaServiceITADto>,
    private documentService: CommonService<Documento>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private toastr: ToastrService,
    public translate: TranslateService) { }

  ngOnInit() {
    this.idTipologia = this.activatedRoute.snapshot.paramMap.get('idtipologia')
    console.log('idtipologia service ita', this.idTipologia);

    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = 'SERVICEITA.TITLE';

    const url = 'api/rest/GetDocumentTypeByIdTipologia';
    const input = {
      params: { idtipologia: this.idTipologia, azienda: 'ServiceITA' }
    };
    this.tipologiaService.getData(url, input, false).subscribe(data => {
      console.log('data from observable tipologia service ita arcadoc', data);
      this.tipologia = data;
      this.documentType = this.tipologia['tipoDocumento'][0];
    });
  }

  setDocumentType(docType) {
    console.log('doctype', docType);
    this.documentType = docType;
  }

  callBarcadoc() {
    //console.log('callbarcadoc', this.documentType);

    const url = 'api/rest/LoadFilteredDocuments';

    const input = { idtipologia: this.tipologia.idTipologia, customtag: this.tipologia.labelCampoTipoDocumento + ',' + this.documentType };  // Attenzione così gestisce un solo filtro. Per più di un filtro usare '#' come separatore filtri
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is documents : ', result);
        this.documents = result as Documento[];

        if (this.documents.length > 0) {

          this.documents.forEach((x, i) => {
            x.isCollapsed = true;
            x.metadatiDtoList.forEach(item => {
              let s = item.key.replace(/_/g, " ");
              console.log(s);
              item.key = s;
            });
            x.bg = 'mat-card-header-gray';
            x.active = 'titleTab';
          });
        } else {
          console.log('no content');

          this.translate.get(["SERVICEITA.NOCONTENT"]).subscribe(values => {
            this.toastr.info(values["SERVICEITA.NOCONTENT"]);
          });
        }

      }
    }, error => console.error('error on get documenti', error));
  }

  setFlagLetturaInArcadoc(iddocumento) {

    const url = 'api/rest/setFlagLetturaInArcadoc';
    const input = { iddocumento: iddocumento };

    this.documentService.postData(url, input, false).subscribe(result => {
      console.log('Setflaglettura esguito: ' + result);
    }, error => console.error('error ', error));
  }

  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

  getArcadocAttach(item: AttachmentDto, iddocumento) {

    const url = 'api/rest/GetAttachment';

    const params = { params: { idAllegato: item.idAllegato, idDocument: iddocumento, fileName: item.nomeFile, download: true } };
    this.fileServer.getData(url, params, false).toPromise().then(res => {

      console.log(res);

      const attachment: AttachmentDto = res as AttachmentDto;

      const ext = attachment.nomeFile.split('.').pop();
      const downloadLink = document.createElement("a");
      const fileName = attachment.nomeFile;

      this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
        const url = URL.createObjectURL(blob);
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
      })
    });
  }
}
